<template>
  <v-dialog :value="isActive" max-width="390" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="text-h5"> Удалить элементы? </v-card-title>

      <v-card-text>
        Вы действительно хотите удалить выбраный элемент?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey darken-1" text @click="closeDialog"> Отмена </v-btn>

        <v-btn color="error darken-1" text @click="deleteItemHandler">
          <v-icon class="mr-1">mdi-delete</v-icon> Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
  },

  methods: {
    closeDialog() {
      this.$emit("closeRemoveItemDialog");
    },

    deleteItemHandler() {
      this.$emit("removeItem");
    },
  },
};
</script>

<style></style>
